import { tagAnatomy as g } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as v, cssVar as t, defineStyle as d } from "@chakra-ui/styled-system";
import { badgeVars as c, badgeTheme as n } from "./badge.mjs";
const { defineMultiStyleConfig: u, definePartsStyle: a } = v(g.keys), m = t("tag-bg"), f = t("tag-color"), b = t("tag-shadow"), r = t("tag-min-height"), l = t("tag-min-width"), o = t("tag-font-size"), s = t("tag-padding-inline"), h = d({
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [f.variable]: c.color.reference,
  [m.variable]: c.bg.reference,
  [b.variable]: c.shadow.reference,
  color: f.reference,
  bg: m.reference,
  boxShadow: b.reference,
  borderRadius: "md",
  minH: r.reference,
  minW: l.reference,
  fontSize: o.reference,
  px: s.reference,
  _focusVisible: {
    [b.variable]: "shadows.outline"
  }
}), p = d({
  lineHeight: 1.2,
  overflow: "visible"
}), S = d({
  fontSize: o.reference,
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _active: {
    opacity: 1
  }
}), w = a({
  container: h,
  label: p,
  closeButton: S
}), y = {
  sm: a({
    container: {
      [r.variable]: "sizes.5",
      [l.variable]: "sizes.5",
      [o.variable]: "fontSizes.xs",
      [s.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: a({
    container: {
      [r.variable]: "1.75rem",
      //'sizes.6',
      [l.variable]: "1.75rem",
      //'sizes.6',
      [o.variable]: "fontSizes.xs",
      [s.variable]: "space.2"
    }
  }),
  lg: a({
    container: {
      [r.variable]: "sizes.8",
      [l.variable]: "sizes.8",
      [o.variable]: "fontSizes.sm",
      [s.variable]: "space.3"
    }
  })
}, z = {
  subtle: a((i) => {
    var e;
    return {
      container: (e = n.variants) == null ? void 0 : e.subtle(i)
    };
  }),
  solid: a((i) => {
    var e;
    return {
      container: (e = n.variants) == null ? void 0 : e.solid(i)
    };
  }),
  outline: a((i) => {
    var e;
    return {
      container: (e = n.variants) == null ? void 0 : e.outline(i)
    };
  }),
  solidPill: a((i) => {
    var e;
    return {
      container: {
        ...(e = n.variants) == null ? void 0 : e.solidPill(i),
        fontWeight: "medium",
        letterSpacing: "normal",
        lineHeight: "5"
      },
      label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    };
  }),
  outlinePill: a((i) => {
    var e;
    return {
      container: {
        ...(e = n.variants) == null ? void 0 : e.outlinePill(i),
        // fontSize: 'xs',
        fontWeight: "medium",
        letterSpacing: "normal",
        lineHeight: "5"
      },
      label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    };
  })
}, $ = u({
  variants: z,
  baseStyle: w,
  sizes: y,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
});
export {
  $ as tagTheme
};
